import { useDeleteAuthorityMutation } from '@/graphql/types';

export default function (authority: { id: string }) {
  const mutation = useDeleteAuthorityMutation({});

  function call() {
    return mutation.mutate({
      id: authority.id
    });
  }

  return {
    ...mutation,
    call
  };
}
